interface Experience {
  company: string;
  role: string;
  period: string;
  description: string;
  highlights: string[];
  tech: string[];
}

const experiences: Experience[] = [
  {
    company: "OY! Indonesia",
    role: "Software Engineer, Platform",
    period: "Sep 2025 - June 2026",
    description:
      "OY! Indonesia is an Indonesian fintech startup company that provides financial services solutions, enabling businesses to process transfers, disbursements, virtual account, and QRIS through a unified platform.",
    highlights: [
      "Focused on engineering within the Platform Team, developing and maintaining payment and inquiry integrations across multiple banks and e-wallet providers.",
      "Maintained backend services with 99% uptime, including 50+ API's, ensuring reliable and highly available payment processing across multiple banks and e-wallet providers supporting more than IDR 100 billion in daily transaction volume.",
      "Act as engineer's on-call, monitoring all products periodically.",
      "Implemented configurable transaction volume limits to enforce daily transaction value thresholds.",
    ],
    tech: ["Java", "Python", "RabbitMQ", "Redis", "Grafana", "Elasticsearch", "Kibana", "PostgreSQL"],
  },
  {
    company: "Bank Rakyat Indonesia (BRI)",
    role: "Fullstack Developer Intern",
    period: "Sep 2024 - Dec 2024",
    description:
      "BRI is one of the largest banks in Indonesia, providing a wide range of banking and financial services with a strong focus on retail banking, microfinance, and digital transformation.",
    highlights: [
      "Developed a fullstack web-based internal system to manage outsourced workers across departments, improving tracking, assignment, and reporting processes.",
      "Developed a fullstack system using CodeIgniter and PHP for both backend and frontend.",
      "Collaborated with the external teams to create product requirement document and engaged in user acceptance testing (UAT) with QA.",
    ],
    tech: ["CodeIgniter", "PHP"],
  },
];

export default experiences;
